import { TrasmissioneIntegrazione } from "app/forms/comunicazioni/trasmissione-integrazione/trasmissione-integrazione";
import { TrasmissionePagamento } from "app/forms/comunicazioni/trasmissione-pagamento/trasmissione-pagamento";
import { Cantiere } from "app/forms/osp/cantiere/cantiere";
import { Commercio } from "app/forms/osp/commercio/commercio";
import { Dehor } from "app/forms/osp/dehor/dehor";
import { Manifestazione } from "app/forms/osp/manifestazione/manifestazione";
import { NullaOsta } from "app/forms/osp/nullaosta/nullaosta";
import { PassoCarraio } from "app/forms/osp/passocarraio/passocarraio";
import { Scavo } from "app/forms/osp/scavo/scavo";
import { Urgenza } from "app/forms/osp/urgenza/urgenza";
import { DelegatoStep } from "app/forms/shared/delegato.step";

const WMS_PUC = "https://sue.comune.rapallo.ge.it/rapallowms/qgispuc/service?";

const jsonForms={};

jsonForms['cantiere'] = Cantiere;
jsonForms['dehor'] = Dehor;
jsonForms['manifestazione'] = Manifestazione;
jsonForms['scavo'] = Scavo;
jsonForms['passocarraio'] = PassoCarraio;
jsonForms['commercio'] = Commercio;
jsonForms['nullaosta'] = NullaOsta;
jsonForms['urgenza'] = Urgenza;
jsonForms['integrazione'] = TrasmissioneIntegrazione
jsonForms['pagamento'] = TrasmissionePagamento
jsonForms['delegato'] = DelegatoStep


export const environment = {
    production: false,
    gmap: true,
    segnalazioni: false,
    prenotazioni: false,
    maxSizeAllegati:100, //massima dimensione complessiva allegati istanza im MB
    portal_url:'https://www.comune.rapallo.ge.it',
    scrivania_url:'https://www.comune.rapallo.ge.it/area_authspid/pagsistema.html',
    comune: "RAPALLO",
    privacy_link:'https://www.comune.rapallo.ge.it/pagina144842_informativa-privacy.html',
    regione: 'liguria',
    DPO_comune:"Comune di Rapallo",
    DPO_sede:"Piazza Molfino, 10, Rapallo (GE)",
    DPO_nome:"Avv. Massimo Ramello",
    DPO_email:"comune.rapallo@gdpr.nelcomune.it - PEC dpo@pec.gdpr.nelcomune.it TEL 01311826681",
    wmsLayers: [
        { id: 'puc', title: 'PUC', url: WMS_PUC, layers: 'qgis_puc_tiles', active: true }
    ],
    jsonForms: jsonForms
};
